import React from 'react';
import { Linkedin, Twitter, Github, Mail } from 'lucide-react';
export function Footer() {
  return <footer className="py-12 border-t border-border bg-base" data-id="element-110">
      <div className="container mx-auto px-6 md:px-12" data-id="element-111">
        <div className="flex flex-col md:flex-row justify-between items-center gap-6" data-id="element-112">
          <div data-id="element-113">
            <span className="font-serif text-xl font-medium tracking-tight block mb-1" data-id="element-114">
              Alex Circei
            </span>
            <span className="text-sm text-secondary" data-id="element-115">
              Engineering Leadership Advisor • CEO, Waydev
            </span>
          </div>

          <div className="flex items-center gap-6" data-id="element-116">
            <a href="#" className="text-muted hover:text-primary transition-colors" data-id="element-117">
              <Linkedin className="w-5 h-5" data-id="element-118" />
              <span className="sr-only" data-id="element-119">LinkedIn</span>
            </a>
            <a href="#" className="text-muted hover:text-primary transition-colors" data-id="element-120">
              <Twitter className="w-5 h-5" data-id="element-121" />
              <span className="sr-only" data-id="element-122">Twitter</span>
            </a>
            <a href="#" className="text-muted hover:text-primary transition-colors" data-id="element-123">
              <Github className="w-5 h-5" data-id="element-124" />
              <span className="sr-only" data-id="element-125">GitHub</span>
            </a>
            <a href="mailto:alex.circei@gmail.com" className="text-muted hover:text-primary transition-colors" data-id="element-126">
              <Mail className="w-5 h-5" data-id="element-127" />
              <span className="sr-only" data-id="element-128">Email</span>
            </a>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-border/50 flex flex-col md:flex-row justify-between items-center gap-4 text-xs text-muted" data-id="element-129">
          <p data-id="element-130">© {new Date().getFullYear()} Alex Circei. All rights reserved.</p>
          <div className="flex gap-6" data-id="element-131">
            <a href="#" className="hover:text-secondary transition-colors" data-id="element-132">
              Privacy Policy
            </a>
            <a href="#" className="hover:text-secondary transition-colors" data-id="element-133">
              Terms of Service
            </a>
          </div>
        </div>
      </div>
    </footer>;
}